import React from 'react';
import { connect } from 'react-redux'
import ConfiguratorPage from './ConfiguratorPage.react';
import ConfiguratorRightCol from './ConfiguratorRightCol.react';
import { FormattedMessage } from 'react-intl';

class ConfiguratorPageAndContent extends React.Component {

    static get defaultProps() {
        return {
            ConfiguratorManager: {}
        }
    }

    componentDidMount() {

        const steps = [
            {
                title: <FormattedMessage id='TEXT_FEATURE_TOUR_CONFIGURATOR_TITLE_3' />,
                text: <FormattedMessage id='TEXT_FEATURE_TOUR_CONFIGURATOR_MESSAGE_3' />,
                selector: '.configurator-main',
                position: 'right',
            },
            {
                title: <FormattedMessage id='TEXT_FEATURE_TOUR_CONFIGURATOR_TITLE_4' />,
                text: <FormattedMessage id='TEXT_FEATURE_TOUR_CONFIGURATOR_MESSAGE_4' />,
                selector: '.configurator-right-col',
                position: 'left',
            },
        ];

        this.props.checkSubcomponentMounted ? this.props.checkSubcomponentMounted() : null;
        this.props.addSteps ? this.props.addSteps(steps) : null;
    }

    render() {

        let { ConfiguratorManager, validatePage } = this.props;

        return (
            <div>
                <div className="col-sm-8 col-md-8 col-xs-8 col-sm-offset-2 col-xs-offset-2 main configurator-main">
                    <ConfiguratorPage ConfiguratorManager={ConfiguratorManager} />
                </div>
                <div className="col-sm-2 col-xs-2">
                    <ConfiguratorRightCol ConfiguratorManager={ConfiguratorManager} validatePage={validatePage} />
                </div>
            </div>
        );
    }
}

export default connect(state => ({ configurator: state.configurator }))(ConfiguratorPageAndContent);


// WEBPACK FOOTER //
// ./src/js/components/ConfiguratorPageAndContent.react.jsx